<template>
	<dialog-form
		:dialogVisible="showDialog"
		:attributes="{
			title: enquiryDetail.title,
			...attributes,
		}"
		:showBtn="false"
		@close:dialogVisible="close"
	>
		<div slot="main">
			<!-- 详情 -->
			<div class="dialog-content">
				<el-row type="flex" justify="space-between">
					<el-col class="info" :span="6">客户：{{ enquiryDetail.customerName || '-' }}</el-col>
					<el-col class="info" :span="6"
						>行业：{{ enquiryDetail.primaryIndustryName }} -
						{{ enquiryDetail.secondIndustryName }}</el-col
					>
					<el-col class="info" :span="6">发件人：{{ enquiryDetail.senderEmail || '-' }}</el-col>
					<el-col class="info" :span="6">收件人：{{ enquiryDetail.recipientEmail || '-' }}</el-col>
				</el-row>

				<el-row type="flex" justify="space-between">
					<el-col class="info" :span="6">发送时间：{{ enquiryDetail.sendTime || '-' }}</el-col>
					<el-col class="info" :span="6"> 客户域名：{{ enquiryDetail.domain || '-' }}</el-col>
					<el-col class="info" :span="6">审核时间：{{ enquiryDetail.auditTime || '-' }}</el-col>
					<el-col class="info" :span="6">审核人：{{ enquiryDetail.auditorName || '-' }}</el-col>
				</el-row>

				<el-row type="flex" justify="space-between">
					<el-col class="info" :span="6"
						>{{ enquiryDetail.type == 2 ? '不通过' : '通过' }}原因：{{
							enquiryDetail.auditTypeName || '-'
						}}</el-col
					>
					<el-col class="info" :span="6"> 备注：{{ enquiryDetail.remarks || '-' }}</el-col>
				</el-row>
				<!-- 拓展内容 -->
				<el-row
					type="flex"
					justify="space-between"
					class="expend-content"
					v-if="enquiryDetail.expandContent"
				>
					<el-divider content-position="left"></el-divider>
					<el-col
						class="info"
						:span="6"
						v-for="(item, index) in enquiryDetail.expandContent"
						:key="index"
						>{{ item }}</el-col
					>
				</el-row>
				<el-divider content-position="left">内容</el-divider>
				<!-- 富文本 -->
				<div v-if="enquiryDetail.inquiryType !== 5" class="rich-text">
					<shadow-dom :content="enquiryDetail.contentHtml || enquiryDetail.content"></shadow-dom>
				</div>
				<!-- 聊天记录 -->
				<chat-frame
					v-else
					:chatData="enquiryDetail.fbChatRecordShowVO"
					class="chat-frame"
				></chat-frame>
			</div>
			<!-- 详情按钮 -->
			<el-row type="flex" justify="end" class="endit-btn" v-if="!showPass">
				<el-button
					v-for="item in filterDetailBtnList"
					:key="item.name"
					:loading="
						butLoading &&
						item.attributes &&
						item.attributes.type &&
						item.attributes.type === 'primary'
					"
					v-bind="item.attributes"
					v-show="!item.hideBtn"
					@click="item.btnClick"
					>{{ item.name }}</el-button
				>
			</el-row>

			<!-- 不通过原因 -->
			<el-row type="flex" justify="space-between" class="no-pass" v-if="showPass">
				<el-col :span="14">
					<h3>{{ formGroup.dictionaryCode.title }}</h3>
					<form-combination ref="noPass" labelWidth="0px" :form-data="formGroup"></form-combination>
				</el-col>
				<el-col :span="8" class="hint">
					<div class="item">
						*若询盘中存在黑名单中的关键词，则询盘会自动归类为垃圾询盘，请谨慎添加
					</div>
					<div class="item">
						*若询盘中的邮箱信息属于黑名单中的邮箱地址，则询盘会自动归类为垃圾询盘
					</div>
					<div class="item">*若询盘中的内容与黑名单中的内容相同，则询盘会自动归类为垃圾询盘</div>
				</el-col>
			</el-row>
			<!-- 不通过原因按钮 -->
			<el-row type="flex" justify="end" v-if="showPass">
				<el-button
					v-for="item in formBtnList"
					:key="item.name"
					:loading="
						butLoading &&
						item.attributes &&
						item.attributes.type &&
						item.attributes.type === 'primary'
					"
					v-bind="item.attributes"
					@click="item.btnClick"
					>{{ item.name }}</el-button
				>
			</el-row>
		</div>
	</dialog-form>
</template>

<script>
import dialogForm from '@/components/dialogForm/dialogForm.vue';
import shadowDom from '@/components/shadowDom/shadowDom';
import chatFrame from '@/components/client/inquiry/chatFrame.vue';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
export default {
	props: {
		showDialog: {
			type: Boolean,
			default: false,
		},
		enquiryDetail: {
			type: Object,
		},
		formGroup: {
			type: Object,
		},
		detailBtnList: {
			type: Array,
		},
		formBtnList: {
			type: Array,
		},
		showPass: {
			type: Boolean,
		},
		butLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			attributes: {
				top: '1vh',
				'close-on-click-modal': false,
			},
		};
	},
	computed: {
		filterDetailBtnList() {
			return this.detailBtnList.filter(item => !item.headBtn);
		},
	},
	methods: {
		close() {
			this.$emit('close:dialogVisible', false);
		},
		validate() {
			let refsVal;
			this.$refs.noPass.validate(val => {
				refsVal = val;
			});
			return refsVal;
		},
		clearValidate(props) {
			this.$refs['noPass'].clearValidate(props);
		},
	},
	components: { dialogForm, shadowDom, chatFrame, formCombination },
};
</script>

<style lang="scss" scoped>
.dialog-content {
	padding: 10px;
	box-sizing: border-box;
	.info {
		line-height: 1.5em;
		margin: 8px 0;
		font-size: 14px;
		color: #333;
	}
	.expend-content {
		flex-wrap: wrap;
	}
	.chat-frame {
		width: 100%;
		height: 600px;
		box-sizing: border-box;
	}
	.rich-text {
		height: 190px;
		overflow-y: auto;
	}
	// 改变滚动条样式
	.rich-text::-webkit-scrollbar {
		width: 4px;
	}
	.rich-text::-webkit-scrollbar-thumb {
		background-color: #d8d8d8;
		border-radius: 2px;
	}
	.rich-text::-webkit-scrollbar-track {
		background-color: #fff;
		border-radius: 2px;
	}
}
.endit-btn {
	margin: 40px 0 20px;
}

.no-pass {
	margin-top: 10px;
	border-top: 1px solid #dcdfe6;
	.hint {
		font-size: 12px;
		color: #999;
		line-height: 1.5em;
		margin-top: 36px;
		.item {
			margin: 10px 0 45px;
		}
	}
}
</style>
